export enum SummaryFields {
    all='all',
    online = 'online',
    offline = 'offline',
    alarms = 'alarms'
  }
  